import list from "@/pages/commission/list";
import view from "@/pages/commission/view";


const routes = [
  {
    path: "/Commission/Manage",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/Commission/View/:id",
    component: view,
    meta: {requiredAuth: true},
  },
]

export default routes